export const BIEventIds = {
  severity: {
    info: 10,
    warning: 20,
    error: 30,
    fatal: 40
  },
  BIEventsIds: {
    responseTime: '110',
    uploadSpeed: '142',
    uploadQueueStarted: '303',
    uploadQueueFinished: '304',
    resumableUploadStarted: '155',
    resumableUploadFinished: '156',
    resumableChunkUploadStarted: '157',
    resumableChunkUploadFinished: '158',
    apiTiming: '159',
    debugDuplexerEvent: '305'
  },
  BIAdaptersIds: {
    private: '01',
    public: '02',
    facebook: '03',
    flickr: '04',
    instagram: '05',
    flickrSearch: '07',
    googleSearch: '08',
    bigStock: '09',
    collection: '10',
    drive: '11',
    dropbox: '12',
    facebookVideo: '13',
    instagramVideo: '14',
    vimeo: '15',
    vimeoSearch: '16',
    youtube: '17',
    youtubeSearch: '18'
  },
  BIAdaptersRequestsIds: {
    'folders.list': '01',
    'folders.remove': '02',
    'folders.trash.list': '03',
    'folders.trash.restore': '04',
    'folders.trash.remove': '05',
    'folder.create': '06',
    'folder.update': '07',
    'items.list': '11',
    'items.remove': '12',
    'items.search': '13',
    'items.searchByTag': '14',
    'items.trash.list': '15',
    'items.trash.restore': '16',
    'items.trash.remove': '17',
    'item.get': '18',
    'item.update': '19',
    'item.upload': '20',
    'item.uploadByUrl': '21',
    'trash.remove': '22',
    'trash.restore': '23'
  }
};